<template>
    <Transition name="web-faq-slide">
        <div class="faqCatContainer d-flex flex-column border-end">
            <CategoryCard v-for="category in categories" :key="category.id" :category="category"
                        :selectCat="selectCat" :selected="selected" />
        </div>
    </Transition>
</template>
<script>
import CategoryCard from './CategoryCard.vue';


export default {
    props: { categories: { type: Array }, selectCat: { type: Function }, selected: { type: Object } },

    components: { CategoryCard },

    data() {
        return {
        }
    },

    methods: {


    }
}
</script>